module.exports = __webpack_public_path__ + "img/4.d8bda8f1.jpg";